import { TextSpan } from '../../../Atoms/Text';

/** The tag on a line left out of the baseline. */
export const OutOfScopeTag = () => (
  <TextSpan
    size="xs"
    color="grey6"
    className="whitespace-nowrap rounded-full bg-grey-2 px-2 py-0.5">
    Out of scope
  </TextSpan>
);
